import clsx from 'clsx';
import { HTMLAttributes, ReactNode } from 'react';
import { Button, ButtonProps } from '../Button/Button';

export interface EmptyStateProps {
    title?: string;
    description?: string | ReactNode;
    icon?: ReactNode;

    titleProps?: HTMLAttributes<HTMLHeadingElement>;
    descriptionProps?: HTMLAttributes<HTMLParagraphElement>;
    wrapperProps?: HTMLAttributes<HTMLDivElement>;
    buttonProps?: ButtonProps;
}

export function EmptyState(props: EmptyStateProps): ReactNode {
    const { icon, title, description } = props;

    const titleProps = props.titleProps ?? {};
    const descriptionProps = props.descriptionProps ?? {};
    const wrapperProps = props.wrapperProps ?? {};
    const buttonProps = props.buttonProps ?? {};

    const wrapperClassName = clsx(
        'flex flex-column align-items-center p-4 gap-2',
        wrapperProps?.className,
    );
    const titleClassName = clsx(wrapperProps.className, titleProps.className);
    const descriptionClassName = clsx(
        'text-center',
        descriptionProps?.className,
    );
    const buttonClassName = clsx('mt-2', buttonProps?.className);

    return (
        <div {...wrapperProps} className={wrapperClassName}>
            {icon}

            {/* Title template */}
            {title || props.titleProps ? (
                <h2 {...titleProps} className={titleClassName}>
                    {title ? title : titleProps.content}
                </h2>
            ) : null}

            {/* Description template */}
            {description || props.descriptionProps ? (
                <p {...descriptionProps} className={descriptionClassName}>
                    {description ? description : descriptionProps.content}
                </p>
            ) : null}

            {/* Button template */}
            {props.buttonProps ? (
                <Button {...buttonProps} className={buttonClassName} />
            ) : null}
        </div>
    );
}
